import { render, staticRenderFns } from "./GiftCardHome.vue?vue&type=template&id=60aecb62&"
import script from "./GiftCardHome.vue?vue&type=script&lang=js&"
export * from "./GiftCardHome.vue?vue&type=script&lang=js&"
import style0 from "./GiftCardHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports